import { isRight } from 'fp-ts/lib/Either';
import { createSelector } from 'reselect';
import { SearchParams } from 'src/state/SearchParams';
import { SearchParamsType } from 'src/types/SearchParamsType';
import { getUrlQueryString } from 'src/selectors/getUrlQueryString';

export const getUrlQueryParams = createSelector([
    getUrlQueryString,
], (queryString): SearchParams => {
    const result = SearchParamsType.decode({
        query: queryString.get('query'),
        section: queryString.get('section'),
    });

    return isRight(result)
        ? result.right
        : { query: '', section: null };
});
